import React, { Component } from 'react';
import AppSidebar from "../components/AppSidebar";
import PageHeader, {isAdvancedMode} from "../components/PageHeader";
import PanelGroupController from "../components/PanelGroupController";
import PanelHeaderItem from "../components/PanelHeaderItem";
import FilterPanel from "../components/panels/FilterPanel";
import SearchQueriesPanel from "../components/panels/SearchQueriesPanel";
import NotesPanel from "../notes/panels/NotesPanel";
import MetaOrderList from "./views/MetaOrderList";
import MetaOrderInfoPanel from "./panels/MetaOrderInfoPanel";
import ShippingInfoPanel from "../shipping/panels/ShippingInfoPanel";
import ShippingStatusPanel from "../shipping/panels/ShippingStatusPanel";
import {getAllShopsWithAllOption} from "../lib/Shops";
import {
  requestCancelMetaOrder,
  requestRefundMetaOrder,
  requestViewMetaOrderHistory,
} from "../actions/SalesApiActions";
import {connect} from "react-redux";
import {withApollo} from "react-apollo";
import {List, fromJS, Map} from "immutable";
import { requestCreateNote } from "../notes/NotesActions";
import { META_ORDER_TYPE } from '../notes/notes';
import ActionButton from '../components/ActionButton';

const sourceFilterOptions = fromJS([
  {id: "", label: "All"},
  {id: "facebook", label: "Facebook"},
  {id: "instagram", label: "Instagram"},
])

const stateFilterOptions = fromJS([
  {id: "", label: "Any"},
  {id: "CREATED", label: "Created"},
  {id: "IN_PROGRESS", label: "In Progress"},
  {id: "COMPLETED", label: "Completed"},
])

const typeFilterOptions = fromJS([
  {id: "", label: "All"},
  {id: "tests_only", label: "Test only"},
  {id: "hide_tests", label: "No Tests"},
]);

const searchOptions = fromJS([
  {prop: "metaOrderId", label: "Meta order Id", type: "string"},
  {prop: "shippingOrderId", label: "Shipping order Id", type: "string"},
])

class MetaOrdersPage extends Component {

  constructor(props) {
    super(props);
    this.handleSetSelection = this.handleSetSelection.bind(this);
    this.handleViewOrderId = this.handleViewOrderId.bind(this);
    this.handlePanelItemSelection = this.handlePanelItemSelection.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.state = {
      orderId: "",
      hasOrderSelection: false,
      selectedPanelId: "general",
      shopFilter: "",
      sourceFilter: "",
      stateFilter: "",
      typeFilter: "hide_tests",
    }
  }

  componentDidMount() {
    if (this.props.route.page === "metaOrder") {
      this.setState({orderId: this.props.params.orderId, selectedPanelId: "properties"});
    }
  }

  componentDidUpdate(prevProps, prevState) {
    let changes = false;
    let newState = {};
    if (prevProps.params.orderId !== this.props.params.orderId) {
      changes = true;
      newState.orderId = this.props.params.orderId;
    }
    if (this.props.route.page === "metaOrder" && (this.state.selectedPanelId === "general" || this.state.selectedPanelId === "search")) {
      changes = true;
      newState.selectedPanelId = "properties";
    }

    if (changes) {
      this.setState(newState);
    }
  }

  render() {
    const page = this.props.route.page;
    
    let view = this.renderView(page);
    let panels = this.renderPanels(page);

    let title = "Orders";
    if (page === "metaOrder") {
      title = `${title} / ${this.state.orderId}`;
    }

    const baseClasses = [
      "SalesPage MetaOrdersPage SecurePage",
      isAdvancedMode(this.props.router.location.query) ? "advancedMode" : null,
    ];

    return (
      <div className={baseClasses.join(" ")}>
        <AppSidebar />
        <PageHeader title={title} backButton={page === "metaOrder"} onBack={this.handleBack}
          router={this.props.router} />
        <div className="PageContainer">
          {view}
        </div>
        <div className="PanelContainer">
          <div className="header">
            <PanelHeaderItem show={page==="metaOrders"} label="Filter" id="general" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
            <PanelHeaderItem show={page==="metaOrders"} label="Search" id="search" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
            <PanelHeaderItem show={true} label="Properties" id="properties" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
            <PanelHeaderItem show={page==="metaOrder"} label="History" id="history" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
            <PanelHeaderItem show={page==="metaOrder" || this.state.hasOrderSelection} label="Notes" id="notes" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
          </div>
          {panels}
          <PanelGroupController title="Actions">
            <ActionButton
              label="Show Order History"
              active={this.state.hasOrderSelection}
              onClick={this.handleViewMore.bind(this)} />
            <ActionButton
              label="Cancel Meta Order"
              active={this.state.hasOrderSelection}
              onClick={this.handleCancelOrder.bind(this)} />
            <ActionButton
              label="Refund Meta Order"
              active={this.state.hasOrderSelection}
              onClick={this.handleRefundOrder.bind(this)} />
            <ActionButton
              label="Annotate Order" 
              show={(page === "metaOrders" && this.state.hasOrderSelection) || page === "metaOrder"}
              onClick={this.handleAnnotateOrder.bind(this)} />

          </PanelGroupController>
        </div>
      </div>
    );
  }

  renderView(page) {
    let searchQueries = Map(this.props.router.location.query);
    let typeFilter = this.state.typeFilter;
    const orderIdFilter = this.props.router.params.orderId || "";
    
    switch(page) {
      case "metaOrder":
        typeFilter = ""; // Forces no filter for individual order
      
      case "metaOrders":
        // Same as metaOrders, no detail view necessary
        // falls through
        return (
          <MetaOrderList
            selectedId={this.state.orderId} 
            onSelectionChange={this.handleSetSelection}
            onIdClick={this.handleViewOrderId}
            filters={{
              shopId: this.state.shopFilter,
              state: this.state.stateFilter,
              source: this.state.sourceFilter,
              type: typeFilter,
              metaOrderId: orderIdFilter,
              shippingOrderId: searchQueries.get("shippingOrderId", ""),
            }}
            advancedMode={isAdvancedMode(this.props.router.location.query)}
          />
        );
      default: 
        return <p>No view found</p>
    }
  }

  renderPanels(page) {
    switch(page) {
      case "metaOrders":
        if (this.state.selectedPanelId === "general") {
          const filtersList = ["shopFilter", "stateFilter", "sourceFilter", "typeFilter"];
          return this.buildPanels(List(filtersList));
        } else if (this.state.selectedPanelId === "properties" && this.state.hasOrderSelection) {
          return this.buildPanels(List([MetaOrderInfoPanel]));
        } else if (this.state.selectedPanelId === "search") {
          return this.buildPanels(List([SearchQueriesPanel]));
        } else if (this.state.selectedPanelId === "notes") {
          return this.buildPanels(List([NotesPanel]));
        }
        break;
      case "metaOrder":
        if (this.state.selectedPanelId === "properties") {
          return this.buildPanels(List([MetaOrderInfoPanel]));
        } else if (this.state.selectedPanelId === "shipping") {
          return this.buildPanels(List([ShippingStatusPanel, ShippingInfoPanel]));
        } else if (this.state.selectedPanelId === "notes") {
          return this.buildPanels(List([NotesPanel]));
        }
        break;
      default:
        return null;
    }
  }

  buildPanels(panels) {
    return panels.map(x => this.buildPanel(x));
  }

  buildPanel(component) {
    switch(component) {
      case "shopFilter":
        return <FilterPanel
          key="ShopFilterPanel"
          title="Shop Filter"
          expanded={true}
          options={getAllShopsWithAllOption()}
          onClick={this.handleSetShopFilter.bind(this)}
          filter={this.state.shopFilter}
          />

      case "sourceFilter":
        return <FilterPanel
          key="SourceFilterPanel"
          title="Source Filter"
          expanded={true}
          options={sourceFilterOptions}
          onClick={this.handleSetSourceFilter.bind(this)}
          filter={this.state.sourceFilter}
          />

      case "stateFilter":
        return <FilterPanel
          key="StateFilterPanel"
          title="State Filter"
          expanded={true}
          options={stateFilterOptions}
          onClick={this.handleSetStateFilter.bind(this)}
          filter={this.state.stateFilter}
          />

      case "typeFilter":
        return <FilterPanel
          key="TypeFilterPanel"
          title="Type Filter"
          expanded={true}
          options={typeFilterOptions}
          onClick={this.handleSetTypeFilter.bind(this)}
          filter={this.state.typeFilter}
          />

      case SearchQueriesPanel:
        return <SearchQueriesPanel
                key="SearchQueriesPanel"
                expanded={true}
                properties={searchOptions}
                query={Map(this.props.router.location.query)}
                onChange={this.handleSearchParamChange.bind(this)}
                onClear={this.handleSearchClear.bind(this)}
                />

      case "transactionDetails":
        return <PanelGroupController title="Transaction Details" />

      case MetaOrderInfoPanel:
        return <MetaOrderInfoPanel key="MetaOrderInfoPanel" orderId={this.state.orderId} />

      case ShippingStatusPanel:
        return <ShippingStatusPanel key="ShippingStatusPanel" orderId={this.state.shippingOrderId} />

      case ShippingInfoPanel:
        return <ShippingInfoPanel 
                  key="ShippingInfoPanel" 
                  orderId={this.getOrderShippingId(this.state.orderId)} 
                  title="Shipping Order Info" />

      case NotesPanel:
        return <NotesPanel key="NotesPanel" foreignType={META_ORDER_TYPE} foreignId={this.state.orderId} />            

      default:
        return null;      
    }
  }

  handleSetShopFilter(item) {
    this.setState({
      shopFilter: item.get("id")
    });
  }

  handleSetSourceFilter(item) {
    this.setState({
      sourceFilter: item.get("id")
    });
  }

  handleSetStateFilter(item) {
    this.setState({
      stateFilter: item.get("id")
    });
  }

  handleSetTypeFilter(item) {
    this.setState({
      typeFilter: item.get("id")
    });
  }
  
  handleSearchParamChange(prop, value) {
    let searchQueries = Map(this.props.router.location.query)
    if (value === "") {
      searchQueries = searchQueries.delete(prop)
    } else {
      searchQueries = searchQueries.set(prop, value);
    }
    this.props.router.push({
      pathname: "/sales/metaOrders",
      query: searchQueries.toJS()
    });
  }

  handleSearchClear() {
    let searchQueries = Map(this.props.router.location.query);
    let searchOptionKeys = searchOptions.map((val) => val.get("prop"));
    let emptySearchQueries = searchOptionKeys.reduce((acc, key) => {
      return acc.delete(key);
    }, searchQueries);

    this.props.router.push({
      pathname: "/sales/metaOrders",
      query: emptySearchQueries.toJS()
    });
  }

  handlePanelItemSelection(id) {
    this.setState({selectedPanelId: id});
  }

  handleSetSelection(id) {
    this.setState({orderId: id, hasOrderSelection: true, selectedPanelId: "properties"});
  }

  handleViewOrderId(orderId) {
    this.setState({orderId: orderId, hasOrderSelection: true}) 
    this.props.router.push(`/sales/metaOrders/${orderId}`);    
  }

  handleViewMore() {
    this.props.requestViewMetaOrderHistory(this.state.orderId);
  }

  handleCancelOrder() {
    this.props.requestCancelMetaOrder(this.state.orderId);
  }

  handleRefundOrder() {
    this.props.requestRefundMetaOrder(this.state.orderId);
  }

  handleBack() {
    this.props.router.push(`/sales/metaOrders`);
  }

  handleAnnotateOrder(e) {
    this.props.requestCreateNote(META_ORDER_TYPE, this.state.orderId);  
  }

}


// const CHECK_META_ORDER_STATUS = gql`
//   mutation checkMetaOrderStatus($metaOrderId: String!) {
//     checkMetaOrderStatus(metaOrderId: $metaOrderId) {
//       errors { key message }
//     }
//   }
// `;

// const withMutation = compose(
//   graphql(CHECK_META_ORDER_STATUS, {
//     props: ({ mutate }) => ({
//       cancelMetaOrder: (data) => mutate({
//         variables: data
//       })
//     })
//   })
// );


export default connect(null, {requestViewMetaOrderHistory, requestCancelMetaOrder, requestRefundMetaOrder, requestCreateNote})(withApollo(MetaOrdersPage));